import { Button, Icon, InputGroup, Switch } from "@blueprintjs/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { toast, Toaster } from "react-hot-toast";

const Login = () => {
  const [formData, setFormData] = useState({ emailId: "", password: "" });
  const [userType, setUserType] = useState("channel");
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const handleLockClick = (event) => {
    //event.preventDefault();
    setShowPassword(!showPassword);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleUserTypeChange = (checked) => {
    setUserType(checked ? "admin" : "channel");
  };

  const submitLoginForm = async (event) => {
    event.preventDefault();
    let bUrl = `/${userType}/login`;

    const btnPointer = document.querySelector("#login-btn");
    btnPointer.innerHTML = "Please wait..";
    btnPointer.setAttribute("disabled", true);

    try {
      const response = await axios.post(bUrl, formData);
      console.log(response.data);

      if (!response.data.success) {
        toast.error("Wrong Credentials"); // Error toast
        btnPointer.innerHTML = "LOGIN";
        btnPointer.removeAttribute("disabled");
        return;
      }

      localStorage.clear();
      localStorage.setItem("user-token", response.data.accessToken);
      localStorage.setItem("panelAccess", userType);
      localStorage.setItem("companyID", response.data.companyID);

      toast.success("Login successful!"); // Success toast

      setTimeout(() => {
        navigate("/");
      }, 500);
    } catch (error) {
      console.error("Error occurred", error);
      toast.error(
        error.response.data?.message || "An error occurred during login."
      ); // Error toast for network/server errors
      btnPointer.innerHTML = "LOGIN";
      btnPointer.removeAttribute("disabled");
    }
  };

  // login-form
  return (
    <>
      <section className="bg-white">
        <div className="lg:grid lg:min-h-screen lg:grid-cols-12">
          <aside className="relative block h-16 lg:order-last lg:col-span-5 lg:h-full xl:col-span-8">
            <img
              alt="Pattern"
              src={"/bg.jpg"}
              className="absolute inset-0 h-full w-full object-cover"
            />
          </aside>

          <main className="flex items-center justify-center px-8 py-8 sm:px-12 lg:col-span-7 lg:px-16 lg:py-12 xl:col-span-4">
            <div className="max-w-xl lg:max-w-3xl">
              <h1 className="mt-6 text-xl font-bold text-gray-900 sm:text-3xl md:text-4xl">
                Welcome to Saathi <br />
                {userType === "admin" ? "National" : "Channel"} Manager Panel
              </h1>

              <div className="mt-4">
                <label className="swap swap-rotate">
                  <input
                    type="checkbox"
                    className="peer"
                    checked={userType === "admin"}
                    onChange={(e) => handleUserTypeChange(e.target.checked)}
                  />

                  <div className="swap-on flex items-center">
                    <div className="w-11 h-6 bg-red-200 peer-focus:outline peer-focus:outline-red-500 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[22px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-600"></div>
                    <span className="text-red-500 ml-2">National Manager</span>
                  </div>

                  <div className="swap-off flex items-center">
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline peer-focus:outline-red-500 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
                    <span className="text-red-500 ml-2">Channel Manager</span>
                  </div>
                </label>
              </div>

              <form
                id="loginForm"
                onSubmit={submitLoginForm}
                className="mt-8 grid grid-cols-6 gap-6"
              >
                <div className="col-span-8">
                  <input
                    placeholder="Enter your Registered Email ID..."
                    id="login-emailId"
                    name="emailId"
                    type="email"
                    value={formData.emailId}
                    onChange={handleInputChange}
                    className="bg-gray-200 font-bold appearance-none border-2 border-b-red-600 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-red-500"
                  />
                </div>

                <div className="col-span-8 flex">
                  <input
                    placeholder="Enter your password..."
                    id="login-password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                    type={showPassword ? "text" : "password"}
                    className="bg-gray-200 font-bold appearance-none border-2 border-b-red-600 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-red-500"
                  />
                  <button
                    style={{ color: "red" }}
                    icon={showPassword ? "unlock" : "lock"}
                    className="text-red-600 w-16 pr-0.5 inline-block shrink-0 rounded-md border-2 border-red-600 font-bold text-sm font-medium text-white transition  bg-transparent text-red-600 focus:outline-none enabled:focus:ring enabled:active:text-red-500"
                    onClick={handleLockClick}
                  >
                    {!showPassword ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon ml-[3px] icon-tabler icon-tabler-eye-closed"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path d="M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4"></path>
                        <path d="M3 15l2.5 -3.8"></path>
                        <path d="M21 14.976l-2.492 -3.776"></path>
                        <path d="M9 17l.5 -4"></path>
                        <path d="M15 17l-.5 -4"></path>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-eye"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                        <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
                      </svg>
                    )}
                  </button>
                </div>

                <div className="col-span-6 sm:flex sm:items-center sm:gap-4">
                  <button
                    className="inline-block shrink-0 rounded-md border border-red-600 bg-red-600 px-12 py-3 text-sm font-medium text-white transition enabled:hover:border-red-600 enabled:hover:bg-transparent enabled:hover:text-red-600 enabled:focus:outline-none enabled:focus:ring enabled:active:text-red-500"
                    intent="success"
                    id="login-btn"
                    type="submit"
                  >
                    LOGIN
                  </button>
                </div>
              </form>
            </div>
          </main>
        </div>
      </section>
    </>
  );
};

export default Login;
